import { DynamicField, DynamicSections, Facility, PaymentDetailType } from '@cargos/sprintpay-models';
import moment from 'moment';
import { Detail } from '../details';
import { UserPayments } from '../payment/payment';
import { UserProperties } from './user';

export class RhenusUser implements UserProperties, UserPayments {
    constructor(
        private apis: Record<string, string>,
        public dynamicFields: DynamicField[] = [],
        public dynamicSections: DynamicSections[] = []
    ) {
        const paymentURL = this.apis['payments'];

        this.dynamicSections = [
            {
                id: 1,
                label: 'Rhenus Customer Reference',
                orderNumber: 0,
                company: { id: 57, name: 'Rhenus' },
                emailDomain: null,
            },
            {
                id: 2,
                label: 'Payment Details',
                orderNumber: 1,
                company: { id: 57, name: 'Rhenus' },
                emailDomain: null,
            },
            {
                id: 3,
                label: 'Customer Reference',
                orderNumber: 2,
                company: { id: 57, name: 'Rhenus' },
                emailDomain: null,
            },
        ];
        this.dynamicFields = [
            {
                name: 'customerRef',
                label: 'Ops file #',
                section: 2,
                fieldType: 'input',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage:
                    'Your own personal reference # so you can remember this payment. For example your file #.',
                validations: [
                    {
                        id: 0,
                        name: 'pattern',
                        value: [/^[0-9]{3,6}$/],
                        message: 'Enter a minimum of 3 characters and maximum of 6 numeric characters allowed.',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 1,
                        name: 'maxlength',
                        value: '255',
                        message: 'Maximum length exceeded (255 characters maximum)',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your Ops file #.',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 2,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your Ops file #.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'externalReferenceNum',
                label: 'Product',
                section: 2,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                options: [
                    {
                        value: 'Ocean',
                        displayValue: 'Ocean',
                    },
                    {
                        value: 'Air',
                        displayValue: 'Air',
                    },
                    {
                        value: 'Road',
                        displayValue: 'Road',
                    },
                ],
                validations: [
                    {
                        id: 0,
                        name: 'required',
                        value: 'true',
                        message: 'Please enter your Ops file #.',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
            {
                name: 'nameFiles',
                label: 'Please attach the required document(s)',
                section: 1,
                fieldType: 'file',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel:
                    ' Choose a file or drag it here. You may upload at most 3 files .doc, .docx, .pdf or image (jpeg, jpg, png), of max 1MB each.',
                tooltipTitle: '',
                tooltipMessage: '',
                validations: [
                    {
                        id: 0,
                        name: 'required',
                        value: 'true',
                        message: 'Please attach the required document ',
                        title: null,
                        type: 'VALIDATION',
                    },
                    {
                        id: 36,
                        name: 'accept',
                        value: '.docx,.doc,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, image/*',
                        message: 'Files',
                        title: null,
                        type: 'ATTRIBUTE',
                    },
                    {
                        id: 37,
                        name: 'maxfiles',
                        value: '3',
                        message: 'max files validations',
                        title: null,
                        type: 'CODE',
                    },
                    {
                        id: 38,
                        name: 'weight',
                        value: '1',
                        message: 'File weight',
                        title: null,
                        type: 'CODE',
                    },
                    {
                        id: 39,
                        name: 'multiple',
                        value: 'multiple',
                        message: 'multiple',
                        title: null,
                        type: 'ATTRIBUTE',
                    },
                ],
            },
            {
                name: 'locationId',
                label: 'Location',
                section: 0,
                fieldType: 'dropdown',
                company: undefined,
                emailDomain: null,
                isDisabled: false,
                isReplacement: false,
                isHidden: false,
                subLabel: '',
                tooltipTitle: '',
                tooltipMessage: '',
                apiProviderData: `${paymentURL}/customer/approval-flow/information`,
                validations: [
                    {
                        id: 1,
                        name: 'required',
                        value: 'true',
                        message: 'Required field',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }

    public getPaymentDetails = (payment: PaymentDetailType, facility: Facility, id: string): Detail[] => [
        {
            label: facility.externalLookup ? 'File Number' : 'Second facility reference #',
            value: payment.hawb ? payment.hawb : 'N/A',
            show: !facility.externalLookup && !id,
        },
        { label: 'Paid To', value: payment.paidTo ? payment.paidTo : 'N/A', show: true },
        {
            label: 'Cargo facility',
            value: facility.name ? facility.name : 'N/A',
            show: true,
        },
        {
            label: 'Amount',
            value: payment.amount ? '$' + payment.amount.toFixed(2) : 'N/A',
            show: true,
        },
    ];

    public getPaymentCustomerReference = (
        payment: PaymentDetailType,
        customerReferenceLabel: string = ''
    ): Detail[] => [
        {
            label: customerReferenceLabel ? customerReferenceLabel : 'Ops file #',
            value: payment.customerReference ? payment.customerReference : 'N/A',
            show: true,
        },
        {
            label: 'Product',
            value: payment.externalReferenceNum ? payment.externalReferenceNum : 'N/A',
            show: true,
        },
        {
            label: 'Payment notification Email',
            value: payment.notificationEmail ? payment.notificationEmail : 'N/A',
            show: true,
        },
        { label: 'Notes', value: payment.notes ? payment.notes : 'N/A', show: true },
    ];

    public getCustomerInformation = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Customer Name',
            value: payment.customer ? payment.customer.name : 'N/A',
            show: true,
        },
        {
            label: 'Notification email',
            value: payment?.notificationEmail ? payment?.notificationEmail : 'N/A',
            show: true,
        },
        {
            label: 'Created Date',
            value: payment?.createdDate ? moment(payment?.createdDate).format('MMM DD, YYYY') : 'N/A',
            show: true,
        },
    ];

    public getCompanyCustomerReference = (payment: PaymentDetailType): Detail[] => [
        {
            label: 'Payment Amount',
            value: payment?.externalData?.type ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        {
            label: 'Type',
            value: payment?.paymentType ?? 'N/A',
            show: !!(payment?.externalLookup && payment.id),
        },
        { label: 'Location', value: payment?.location ?? 'N/A', show: true },
    ];
}
